"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _request = _interopRequireDefault(require("@/http/request"));
var _store = _interopRequireDefault(require("@/store"));
// import axios from 'axios'
/**
 * 自定义上传图片插件
 */
var ImageUploadAdapter = /*#__PURE__*/function () {
  function ImageUploadAdapter(loader, businessKey, resourceConfigFlag, vueComponent) {
    (0, _classCallCheck2.default)(this, ImageUploadAdapter);
    this.loader = loader;
    this.businessKey = businessKey;
    this.resourceConfigFlag = resourceConfigFlag;
    this.vueComponent = vueComponent;
  }
  return (0, _createClass2.default)(ImageUploadAdapter, [{
    key: "upload",
    value: function () {
      var _upload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var rawFile, data, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.n = 1;
              return this.loader.file;
            case 1:
              rawFile = _context.v;
              if (!(rawFile.size > 50 * 1024 * 1024)) {
                _context.n = 2;
                break;
              }
              this.vueComponent.$message.error(this.vueComponent.$t('common.uploadLimit50M'));
              return _context.a(2, {
                default: ''
              });
            case 2:
              data = new FormData();
              data.append('file', rawFile);
              data.append('businessKey', this.businessKey);
              data.append('resourceConfigFlag', this.resourceConfigFlag);
              _context.p = 3;
              this.vueComponent.isLoading = true;
              _context.n = 4;
              return (0, _request.default)({
                timeout: 5000000,
                headers: {
                  'content-type': 'multipart/form-data'
                },
                url: "/protected/file/upload",
                method: 'POST',
                data: data,
                withCredentials: false // true 为不允许带 token, false 为允许
              });
            case 4:
              res = _context.v;
              this.vueComponent.isLoading = false;
              console.log(res.data);
              // 后台返回数据：
              // {"code":0,"msg":"success","data":{"url":"/upload/struts2.jpeg"}}

              // 方法返回数据格式： {default: "url"}
              return _context.a(2, {
                default: res.data.url + '&token=' + _store.default.getters.sasToken
              });
            case 5:
              _context.p = 5;
              _t = _context.v;
              this.vueComponent.isLoading = false;
              return _context.a(2, {
                default: ''
              });
          }
        }, _callee, this, [[3, 5]]);
      }));
      function upload() {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }]);
}();
var _default = exports.default = ImageUploadAdapter;